import { render, staticRenderFns } from "./ConsigneeForm.vue?vue&type=template&id=119a854b&scoped=true"
import script from "./ConsigneeForm.vue?vue&type=script&lang=js"
export * from "./ConsigneeForm.vue?vue&type=script&lang=js"
import style0 from "./ConsigneeForm.vue?vue&type=style&index=0&id=119a854b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119a854b",
  null
  
)

export default component.exports